export const resultMessages = (state) => state.result_messages